import {withMaterialStyles as defaultWithMaterialStyles, withMaterialTheme as defaultWithMaterialTheme} from "common-components/dist/common/components/Template/withMaterial";

export const withMaterialStyles = defaultWithMaterialStyles;
export const withMaterialTheme = defaultWithMaterialTheme;
